import './styles.scss'

import React from 'react'
import { useValues, useActions } from 'kea'
import Tooltip from 'rc-tooltip'

import Imgix from 'lib/tags/imgix'
import Price from 'lib/tags/price'
import Share from 'lib/icons/share'
import HeartSvg from 'lib/icons/heart'
import shortenString from 'lib/utils/shorten-string'
import redirect from 'lib/utils/redirect-url'
import I18n from 'lib/i18n'

import Heart from '../heart'
import PriceOverlay from '../price/overlay'

import courseLogic from '~/scenes/course/show/logic'
import heartLogic from '../heart/logic'

function TopFloat () {
  const {
    dpr,
    windowWidth,
    course: { avatarAlt, title, price, currency, messageUrlIsInbox, messageUrl },
    user: { firstName, avatarUrl, locationString, url }
  } = useValues(courseLogic)
  const { isInWishlist, isToggling } = useValues(heartLogic)
  const { toggleWishlistStatus } = useActions(heartLogic)
  const { enableSharing, openModal } = useActions(courseLogic)

  const handleMessageClick = () => {
    if (!messageUrlIsInbox && windowWidth >= 760) {
      openModal()
    } else {
      redirect(messageUrl)
    }
  }

  const shortenedFirstName = shortenString(firstName, 16)

  return (
    <div>
      <div className='courses-sticky-top-float large-screen'>
        <div className='tightrow'>
          <div className='floating-header-wrapper left-elements'>
            <div className='image-box'>
              <Imgix src={avatarUrl} width={90} alt={avatarAlt} itemProp='image' dpr={dpr} />
            </div>
            <div className='name-and-other'>
              <div className='top-part'>
                <div>
                  <h3>{shortenedFirstName}</h3>
                  <Heart />
                  {locationString ? (
                    <span className='location'>
                      {locationString.map(chunk => (
                        <span key={chunk.i}>
                          <a href={chunk.url}>{chunk.title}</a>
                          {chunk.last ? null : ', '}
                        </span>
                      ))}
                    </span>
                  ) : null}
                </div>
                <div className='price'>
                  {I18n.t('courses.show.from')} <Price price={price} currency={currency} />{' '}
                  {I18n.t('courses.show.per_hour')}
                  <Tooltip trigger={['hover']} placement='bottom' overlay={<PriceOverlay />}>
                    <div className='shint' />
                  </Tooltip>
                </div>
              </div>
              <div className='bottom-part'>
                <div className='class-title'>{title}</div>
                <div className='four column'>
                  <div>
                    <button className='contact-style class-button custom' onClick={handleMessageClick}>
                      {I18n.t('courses.show_contact.button', { first_name: shortenedFirstName })}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='clearfix' />
      </div>
      <div className='courses-sticky-top-float small-screen'>
        <h5 className='mobile-name'>
          <a href={url}>{firstName}</a>
        </h5>
        <HeartSvg withText isActive={isInWishlist} onClick={isToggling ? null : toggleWishlistStatus} />
        <Share onClick={enableSharing} withText />
      </div>
    </div>
  )
}

export default TopFloat
